import { ElementOf, tuple } from '../common/props';
import { FilterFieldVO } from '@mc/data-filter-react';
import { ExtendedFilter } from './Filters';

export type FilterFieldProps = {
  // velikost znaků
  size?: number;
  filterType: FilterType;
  /**
   * Field může vyvolat spuštění hledání, např. na enter apod.
   */
  onSearch: () => void;
  extendedFilter: ExtendedFilter;
};

export type FilterType = ElementOf<typeof FilterTypes>;
const FilterTypes = tuple('onlyValues', 'default');

export const getFilterFieldFormValuePath = (
  fieldName: string,
  filterType: FilterType
) => {
  switch (filterType) {
    case 'default':
      return `${fieldName}.value`;
    case 'onlyValues':
      return `${fieldName}`;
  }
};

export const getFilterFieldFormEmptyPath = (
  fieldName: string,
  filterType: FilterType
) => {
  switch (filterType) {
    case 'default':
      return `${fieldName}.emptyValue`;
    default:
      throw new Error(
        'emptyValue is not supported for filterType ' + filterType
      );
  }
};

export const getFilterFieldFormNotEmptyPath = (
  fieldName: string,
  filterType: FilterType
) => {
  switch (filterType) {
    case 'default':
      return `${fieldName}.notEmptyValue`;
    default:
      throw new Error(
        'emptyValue is not supported for filterType ' + filterType
      );
  }
};

export const getFilterFieldFormValue = (
  fieldName: string,
  filterType: FilterType,
  formData?: any
) => {
  if (!formData) {
    return undefined;
  }

  switch (filterType) {
    case 'default':
      return formData[fieldName]?.value;
    case 'onlyValues':
      return formData[fieldName];
  }
};

export const getFormFieldObjectIdValue = (
  fieldName: string,
  filterType: FilterType,
  formData?: any
) => {
  if (!formData) {
    return undefined;
  }

  switch (filterType) {
    case 'default': {
      let res: FilterFieldVO<any> = {
        value: formData[fieldName]?.value?.id,
        emptyValue: formData[fieldName]?.emptyValue,
        notEmptyValue: formData[fieldName]?.notEmptyValue,
      };
      return res;
    }
    case 'onlyValues':
      return formData[fieldName]?.id;
  }
};

export const getFormFieldObjectIdsValue = (
  fieldName: string,
  filterType: FilterType,
  formData?: any
) => {
  if (!formData) {
    return undefined;
  }

  switch (filterType) {
    case 'default':
      let res: FilterFieldVO<any[]> = {
        value: formData[fieldName]?.value?.map((v: any) => v.id),
        emptyValue: formData[fieldName]?.emptyValue,
        notEmptyValue: formData[fieldName]?.notEmptyValue,
      };
      return res;
    case 'onlyValues':
      return formData[fieldName]?.map((v: any) => v.id);
  }
};

export type SavedFiltersType = {
  id: string;
  nazev: string;
  filter: object;
  visibleFields?: string[];
};

export enum TableSettingsEnumType {
  FILTER = 'filtr',
  PROFIL = 'profil',
  POHLED = 'pohled',
}
